module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-fluid container-margin-top"
  }, [_c('div', {
    staticClass: "content content-padding"
  }, [_c('h1', [_vm._v("Menus Associados ao Coche")]), _vm._v(" "), _vm._l((_vm.coachCategories), function(category) {
    return (_vm.isDataLoaded) ? _c('div', [_c('div', {
      staticClass: "title-with-selector h3-selector"
    }, [_c('h3', {
      staticClass: "subtitle"
    }, [_c('b', [_vm._v(_vm._s(category.languages[0].pivot.name))])]), _vm._v(" "), _c('state-selector', {
      attrs: {
        "selected": category ? parseInt(category.state_id) : null,
        "target": category,
        "update": 'menu'
      }
    })], 1), _vm._v(" "), (category.slug !== 'panorama') ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-one-quarter"
    }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "flex-container-center"
    }, [_vm._v("\n              " + _vm._s(category.background_color) + "\n              "), _c('div', {
      staticClass: "color-preview",
      style: ({
        backgroundColor: category.background_color
      })
    })])])]), _vm._v(" "), (category.slug !== 'eraumavez') ? _c('div', {
      staticClass: "column is-one-quarter"
    }, [_c('div', [_c('b', [_vm._v("Cor Caixa de Texto")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "flex-container-center"
    }, [_vm._v("\n              " + _vm._s(category.textbox_color) + "\n              "), _c('div', {
      staticClass: "color-preview",
      style: ({
        backgroundColor: category.textbox_color
      })
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "column is-one-quarter"
    }, [_c('div', [_c('b', [_vm._v("Cor do Texto")]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "flex-container-center"
    }, [_vm._v("\n              " + _vm._s(category.text_color) + "\n              "), _c('div', {
      staticClass: "color-preview",
      style: ({
        backgroundColor: category.text_color
      })
    })])])])]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('div', {
      staticClass: "columns is-multiline"
    }, [(category.background_path_1) ? _c('div', {
      staticClass: "column is-12"
    }, [_vm._m(0, true), _vm._v(" "), _c('figure', {
      staticClass: "image coach-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath + category.background_path_1
      }
    })])]) : _vm._e(), _vm._v(" "), (category.background_path_2) ? _c('div', {
      staticClass: "column is-12"
    }, [_vm._m(1, true), _vm._v(" "), _c('figure', {
      staticClass: "image coach-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath + category.background_path_2
      }
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-one-quarter"
    })]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('a', {
      staticClass: "button is-small is-info",
      on: {
        "click": function($event) {
          _vm.goToSlide(category.id)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Slides")])]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('a', {
      staticClass: "button is-small is-info",
      on: {
        "click": function($event) {
          _vm.goToPanorama()
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Panorama")])]) : _vm._e(), _vm._v(" "), (category.slug === 'panorama') ? _c('a', {
      staticClass: "button is-small is-info",
      on: {
        "click": function($event) {
          _vm.goToExterior()
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Exterior")])]) : _vm._e(), _vm._v(" "), (category.slug !== 'panorama') ? _c('a', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          _vm.editCoachEditCategoryModal(category)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          _vm.removeCoachDeleteCategoryModal(category)
        }
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v("Apagar")])]), _vm._v(" "), _c('hr')]) : _vm._e()
  }), _vm._v(" "), (_vm.slideCategories ? _vm.slideCategories.length : null) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Adicionar Menu ao Coche")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.slideCategories), function(category) {
    return _c('option', {
      domProps: {
        "value": parseInt(category.id)
      }
    }, [_vm._v(_vm._s(category.languages[0].pivot.name))])
  }))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    class: {
      'is-disabled': !_vm.selectedCategorySlug
    },
    on: {
      "click": _vm.addCoachEditCategoryModal
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Adicionar")])])])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Background 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Background 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b0dc972!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachCategories.vue
// module id = 330
// module chunks = 1